angular
  .module('company')

  .controller('CompanyHeaderCtrl', [
    '$scope',
    '$filter',
    '$timeout',
    'Confirm',
    'Dialog',
    'LoggedUser',
    'ZohoCompanyBulkSync',
    function(
      $scope,
      $filter,
      $timeout,
      Confirm,
      Dialog,
      LoggedUser,
      ZohoCompanyBulkSync
    ) {
      $scope.isPM = LoggedUser.isPM();

      const confirm = new Confirm();
      const zohoCompanyBulkSync = new ZohoCompanyBulkSync();

      zohoCompanyBulkSync
        .get()
        .then(({ updatedAt }) => ($scope.lastZohoSync = updatedAt))
        .catch(() => {});

      $scope.download = () => {
        confirm.info($filter('translate')('DOWNLOAD_REQUEST')).then(() => {
          $scope.$parent.$broadcast('downloadCompanies');
        });
      };

      $scope.zohoBulkSync = () => {
        new Confirm()
          .show($filter('translate')('zoho.BULK_SYNC_MSG'))
          .then(() => {
            zohoCompanyBulkSync
              .save()
              .then(() => {
                $timeout(() => {
                  new Dialog().success(
                    $filter('translate')('zoho.BULK_SYNC_SUCCESS')
                  );
                }, 250);
              })
              .catch(error => {
                Sentry.captureException(error);
                $timeout(
                  () =>
                    new Dialog().error($filter('translate')('zoho.SYNC_ERROR')),
                  250
                );
              });
          });
      };
    }
  ]);
